export enum DiscoverRouteNames {
  DISCOVER_ROOT = 'DiscoverRoot',
  DISCOVER_LIST = 'DiscoverRoot/List',
}
